"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventManager = void 0;
var events_1 = require("events");
/**
 * Pub/sub for interacting with the AsperaPlugin component.
 * Valid actions are described in pluginActions.ts
 */
var EventManager = /** @class */ (function () {
    function EventManager() {
        this.eventEmitter = new events_1.EventEmitter();
    }
    EventManager.prototype.on = function (event, callback) {
        this.eventEmitter.on(event, callback);
    };
    EventManager.prototype.removeAllListeners = function () {
        this.eventEmitter.removeAllListeners();
    };
    EventManager.prototype.emit = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        this.eventEmitter.emit(event, args);
    };
    return EventManager;
}());
exports.eventManager = new EventManager();
